export enum ReadKeySteps {
  workstationSelection = 'workStationSelection',
  loadingData = 'loadingData',
  dataLoaded = 'dataLoaded',
  error = 'error',
}
